export default {
  nav: {
    categories: 'Kategorier',
    topSites: 'Top-sites',
    compare: 'Sammenlign',
    submitSite: 'Indsend site',
    about: 'Om',
    logIn: 'Log ind',
  },
  common: {
    back: 'Tilbage',
    search: 'Søg',
    loading: 'Indlæser…',
    viewSimilarSites: 'Se lignende sites',
  },
  hero: {
    badge: 'Site discovery-motor',
    titleA: 'Find websites der ligner',
    titleB: 'dine favoritter.',
    titlePrefix: 'Find websites der ligner',
    titleAccent: 'dine favoritter.',
    subtitle: 'Opdag konkurrenter, alternativer og skjulte perler på nettet med præcise lighedsscorer.',
    placeholder: 'Indtast et domæne (fx stripe.com)',
    inputPlaceholder: 'Indtast et domæne (fx stripe.com)',
    step1Label: 'Indtast et domæne',
    step1Desc: 'Skriv en webadresse for at komme i gang',
    step2Label: 'Få matches',
    step2Desc: 'Vores motor finder lignende sider med det samme',
    step3Label: 'Sammenlign og vælg',
    step3Desc: 'Analyser og sammenlign alternativer',
    steps: {
      step1Label: 'Indtast et domæne',
      step1Desc: 'Skriv en webadresse for at komme i gang',
      step2Label: 'Få matches',
      step2Desc: 'Vores motor finder lignende sider med det samme',
      step3Label: 'Sammenlign og vælg',
      step3Desc: 'Analyser og sammenlign alternativer',
    },
  },
  footer: {
    newsletterTitle: 'Hold dig opdateret',
    newsletterDesc: 'Få ugentlige rapporter om trendsites og nye alternativer.',
    emailPlaceholder: 'din@email.dk',
    subscribe: 'Abonnér',
    brandDesc: 'Opdag webbets skjulte forbindelser. Find websites der ligner dine favoritter med præcis scoring.',
    explore: 'Udforsk',
    popular: 'Populært',
    company: 'Virksomhed',
    compareSites: 'Sammenlign sites',
    sitesLike: 'Sites som',
    contact: 'Kontakt',
    faq: 'FAQ',
    removeYourSite: 'Fjern dit site',
    privacyPolicy: 'Privatlivspolitik',
    termsOfService: 'Vilkår',
    rights: 'Alle rettigheder forbeholdes.',
  },
  notFound: {
    title: 'Ups! Siden blev ikke fundet',
    returnHome: 'Tilbage til forsiden',
  },
  submitPage: {
    ctaTitle: 'Kender du en fed hjemmeside?',
    ctaDesc: 'Hjælp os med at vokse ved at indsende sites, du elsker. Det tager kun få sekunder.',
    ctaButton: 'Indsend site',
    pageTitle: 'Indsend et site',
    pageSubtitle: 'Hjælp os ved at indsende et website til indeksering.',
    successTitle: 'Site indsendt!',
    successReviewPrefix: 'Vi gennemgår',
    successReviewSuffix: 'og tilføjer det snart til vores indeks.',
    backHome: 'Tilbage til forsiden',
    domainLabel: 'Domæne *',
    domainPlaceholder: 'fx example.com',
    descriptionLabel: 'Beskrivelse',
    descriptionPlaceholder: 'Kort beskrivelse af websitet',
    categoryLabel: 'Kategori',
    categorySelect: 'Vælg kategori',
    alternativeTo: 'Alternativ til (valgfrit)',
    alternativeNone: 'Ingen — ikke et alternativ',
    emailLabel: 'Din e-mail',
    emailPlaceholder: 'dig@eksempel.dk',
    submitButton: 'Indsend site',
    submitFailed: 'Kunne ikke indsende',
    seoTitle: 'Indsend site | CiteMatch',
    seoDesc: 'Indsend et website til indeksering på CiteMatch.',
  },
};

